import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state:{
    usuario: sessionStorage.getItem('usuario') ? JSON.parse(sessionStorage.getItem('usuario')) : null,
    permissoes: sessionStorage.getItem('permissoes') ? JSON.parse(sessionStorage.getItem('permissoes')) : null,
    filtroPrazo: sessionStorage.getItem('filtroPrazo') ? JSON.parse(sessionStorage.getItem('filtroPrazo')) : null,
    filtroPendencia: sessionStorage.getItem('filtroPendencia') ? JSON.parse(sessionStorage.getItem('filtroPendencia')) : null,
  },
  getters:{
    getUsuario: state =>{
      return state.usuario;
    },
    getPermissoes: state =>{
      return state.permissoes;
    },
    getToken: state =>{
      return state.usuario.token;
    },
    getfiltroPrazo: state =>{
      return state.filtroPrazo;
    },
    getfiltroPendencia: state =>{
      return state.filtroPendencia;
    },
  },
  mutations:{
    setUsuario(state,n){
      state.usuario = n;
    },
    setPermissoes(state,n){
      state.permissoes = n;
    },
    setfiltroPrazo(state,n){
      state.filtroPrazo = n;
    },
    setfiltroPendencia(state,n){
      state.filtroPendencia = n;
    }
  },
  actions: {

  }
})
